import { render, staticRenderFns } from "./DetailedColumnChart.vue?vue&type=template&id=87a0ca02"
import script from "./DetailedColumnChart.vue?vue&type=script&lang=js"
export * from "./DetailedColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports